import { render, staticRenderFns } from "./ManterProcuradorEditar.vue?vue&type=template&id=56f7e7de&scoped=true&"
import script from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"
export * from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7e7de",
  null
  
)

export default component.exports